import React from 'react';
import { SitecoreImageField } from 'components/sitecore-fields';
import gtm from 'general/js/gtm';

class EnhancedStats extends React.Component {
        onClickLink = (link) => {
            gtm.push('Stats Module', 'Click', `${document.title} > ${link.text}`);
        }

        render() {
            const {
                model,
            } = this.props.options;

            return (
                <div className="enhanced-stats__wrapper">
                    <div className="enhanced-stats__background">
                        {
                            (model.desktopImage !== null && model.desktopImage.src !== null) &&
                            <>
                            <SitecoreImageField
                                img={model.desktopImage}
                                className="enhanced-stats__background--desktop">
                            </SitecoreImageField>
                            </>
                        }
                        {
                            (model.mobileImage !== null && model.mobileImage.src !== null) &&
                            <>
                            <SitecoreImageField
                                img={model.mobileImage}
                                className="enhanced-stats__background--mobile"
                            ></SitecoreImageField>
                            </>
                        }
                    </div>
                    <div className="enhanced-stats__content">
                        <div className="enhanced-stats__stats">
                            {
                                model.stat1Value !== '' &&
                                <div className="enhanced-stats__stats__item">
                                    <div className="enhanced-stats__stats__item--label">
                                        {model.stat1Label}
                                    </div>
                                    <div className="enhanced-stats__stats__item--value">
                                        {model.stat1Value}
                                    </div>
                                </div>
                            }
                            {
                                model.stat2Value !== '' &&
                                <div className="enhanced-stats__stats__item">
                                    <div className="enhanced-stats__stats__item--label">
                                        {model.stat2Label}
                                    </div>
                                    <div className="enhanced-stats__stats__item--value">
                                        {model.stat2Value}
                                    </div>
                                </div>
                            }
                            {
                                model.stat3Value !== '' &&
                                <div className="enhanced-stats__stats__item">
                                    <div className="enhanced-stats__stats__item--label">
                                        {model.stat3Label}
                                    </div>
                                    <div className="enhanced-stats__stats__item--value">
                                        {model.stat3Value}
                                    </div>
                                </div>
                            }
                            {
                                model.stat4Value !== '' &&
                                <div className="enhanced-stats__stats__item">
                                    <div className="enhanced-stats__stats__item--label">
                                        {model.stat4Label}
                                    </div>
                                    <div className="enhanced-stats__stats__item--value">
                                        {model.stat4Value}
                                    </div>
                                </div>
                            }
                            {
                                model.stat5Value !== '' &&
                                <div className="enhanced-stats__stats__item">
                                    <div className="enhanced-stats__stats__item--label">
                                        {model.stat5Label}
                                    </div>
                                    <div className="enhanced-stats__stats__item--value">
                                        {model.stat5Value}
                                    </div>
                                </div>
                            }
                            {
                                model.stat6Value !== '' &&
                                <div className="enhanced-stats__stats__item">
                                    <div className="enhanced-stats__stats__item--label">
                                        {model.stat6Label}
                                    </div>
                                    <div className="enhanced-stats__stats__item--value">
                                        {model.stat6Value}
                                    </div>
                                </div>
                            }
                        </div>
                        <div className="enhanced-stats__links">
                            {
                                model.link1 !== null &&
                                <div className="enhanced-stats__links__item">
                                    <a href={model.link1.url} onClick={() => this.onClickLink(model.link1)}>
                                        {model.link1.text}
                                        <svg className="upcoming-opens-links__icon icon" width="14" height="12" focusable="false">
                                            <use xlinkHref="#icon-arrow-right"></use>
                                        </svg>
                                    </a>
                                </div>
                            }
                            {
                                model.link2 !== null &&
                                <div className="enhanced-stats__links__item">
                                    <a href={model.link2.url} onClick={() => this.onClickLink(model.link2)}>
                                        {model.link2.text}
                                        <svg className="upcoming-opens-links__icon icon" width="14" height="12" focusable="false">
                                            <use xlinkHref="#icon-arrow-right"></use>
                                        </svg>
                                    </a>
                                </div>
                            }
                            {
                                model.link3 !== null &&
                                <div className="enhanced-stats__links__item">
                                    <a href={model.link3.url} onClick={() => this.onClickLink(model.link3)}>
                                        {model.link3.text}
                                        <svg className="upcoming-opens-links__icon icon" width="14" height="12" focusable="false">
                                            <use xlinkHref="#icon-arrow-right"></use>
                                        </svg>
                                    </a>
                                </div>
                            }
                            {
                                model.link4 !== null &&
                                <div className="enhanced-stats__links__item">
                                    <a href={model.link4.url} onClick={() => this.onClickLink(model.link4)}>
                                        {model.link4.text}
                                        <svg className="upcoming-opens-links__icon icon" width="14" height="12" focusable="false">
                                            <use xlinkHref="#icon-arrow-right"></use>
                                        </svg>
                                    </a>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            );
        }
}

export default EnhancedStats;
